import { Builder, withChildren } from '@builder.io/react';

import VariantBlock from './variant-block';

const VariantBlockWithChildren = withChildren(VariantBlock);

Builder.registerComponent(VariantBlockWithChildren, {
  name: 'VariantBlock',
  friendlyName: 'Amplitude Variant Block',
  noWrap: false,
  canHaveChildren: true,
  inputs: [
    {
      name: 'experimentKey',
      type: 'string',
      defaultValue: '',
      friendlyName: 'Experiment Name ("Feature Flag ")',
    },
    {
      name: 'showByDefault',
      friendlyName: 'Show Variant By Default',
      type: 'boolean',
    },
    {
      name: 'variantKey',
      friendlyName: 'Variant Value',
      type: 'string',
      defaultValue: 'variant',
    },
  ],
});
